import styled from 'styled-components';
import { media } from '@bitcoin-portal/bitcoincom-pkg-theme';
import Section from '@bitcoin-portal/bitcoincom-pkg-components/dist/Section';

export const StyledSection = styled(Section)`
  padding: 40px 20px;
  background: var(--Shades-0, #fff);
  ${media.md`
    padding: 60px 44px !important;
    padding-top: 36px !important;
    padding-bottom: 72px !important;
  `}
  ${media.lg`
    padding: 60px !important;
  `}
  @media (min-width: 1200px) and (max-width: 1399px) {
    margin: 80px auto !important;
    padding: 0px !important;
    max-width: 1040px !important;
  }

  @media (min-width: 1400px) {
    margin: 80px auto !important;
    padding: 0px !important;
    max-width: 1240px !important;
  }
`;

export const StyledContentBlock = styled.div`
  display: flex !important;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  gap: 20px;
  padding: 0px !important;

  ${media.md`
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 50px;
  `}
`;

export const Title = styled.h2`
  color: var(--Shades-900, #1c1c1c);
  font-family: ${props =>
    props.locale === 'ru'
      ? 'Noto Sans, sans-serif'
      : 'Elza Condensed, sans-serif'};
  font-style: normal;
  font-size: 34px;
  font-weight: ${props => (props.locale === 'ru' ? 900 : 500)};
  line-height: ${props => (props.locale === 'ru' ? '40px' : '89%')};
  letter-spacing: -0.68px;
  text-transform: uppercase;
  margin: 0px;
  align-self: stretch;
  ${media.md`
    font-size: 40px;

    line-height: ${props =>
      props.locale === 'ru' ? '40px !important' : '85% !important'};
    letter-spacing: -0.8px;
  `}
  ${media.lg`
    font-size: 42px;

    letter-spacing: -0.8px;
  `}
  ${media.xl`
    font-size: 46px;
    letter-spacing: -0.92px;
    letter-spacing: -1.4px;
    line-height: ${props =>
      props.locale === 'ru' ? '50px !important' : '85% !important'};
  `}
`;

export const Subtitle = styled.p`
  color: var(--Shades-700, #67656e);
  font-family: 'Satoshi Variable Medium', sans-serif;

  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 135%;
  letter-spacing: -0.32px;

  margin: 0px;
  ${media.md`
    font-size: 20px;

    line-height: 130%;

  `}
  ${media.lg`
    font-size: 21px;
    

    font-weight: 500;
    line-height: 123%;
  `}
  ${media.xl`
    font-size: 22px;
    

    font-weight: 500;
 
  `}
`;

export const ImageWrapper = styled.div`
  display: flex;
  width: 100%;
  position: relative;
  height: 210px;

  border-radius: 16px;
  background: var(--Primary-Defi-Dune, #ffe2c8);
  align-items: center;
  justify-content: center;
  ${media.md`
    height: 260px;
    
  `}
  ${media.lg`
    height: 360px;
    width: 540px;
    
  `}
  ${media.xl`
    height: 420px;
    width: 540px;
    
  `};
`;

export const StyledImage = styled.img`
  display: block;
  border-radius: 16.463px;

  position: absolute;
  top: -20px;
  width: 236px;
  height: 230px;
  ${media.md`
    width: 264px;
    height: 280px;
  `}
  ${media.lg`
    width: 100%;
    height: 380px;
  `}
  ${media.xl`
    width: 484px;
    height: 450px;
    flex-shrink: 0;
    top:-30px;
    
  `};
`;

export const Contentwrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--small, 25px);
  width: 100%;
  ${media.lg`
    width: calc(53.6% - 14px);
  `}
`;
